import axios from 'axios';

/**
 * FallbackService - Simple API client for fallback feature flag values
 * 
 * Provides fallback feature flag values from Parameter Store API when LaunchDarkly is unavailable.
 * Falls back to mock data for testing when API endpoint is not accessible.
 */
class FallbackService {
  constructor() {
  }

  /**
   * Parses a flag value string using JSON.parse.
   * Returns booleans/numbers natively and preserves arbitrary strings as-is.
   * @param {string} str - The raw flag value
   * @returns {*} The parsed value
   */
  _parseValue(str) {
    try { return JSON.parse(str); } catch { return str; }
  }

  /**
   * Fetches fallback feature flag values from Parameter Store API
   * @returns {Promise<Object>} Object containing flags and timestamp
   */
  async fetchFallbackValues() {
    try {
      const response = await axios.get(`${global.REACT_APP_API_ENDPOINT}/featuretoggle/fallback`);
      
      if (response.data && Array.isArray(response.data.flags)) {
        const flagsObject = {};

        response.data.flags.forEach(flagItem => {
          if (flagItem.flagName) {
            flagsObject[flagItem.flagName] = this._parseValue(flagItem.value);
          }
        });
        
        return {
          flags: flagsObject,
          timestamp: Date.now()
        };
      }
      
      throw new Error('Invalid response format');
      
    } catch (error) {
      // Return mock data for testing when API fails
      return {
        flags: {
          'cpm-search-feature': true,
          'cpm-admin-lender-request': false,
          'cpm-lender-add-edit-project': true,
          'cpm-request-grid-internal': true,
          'cpm-lender-add-edit-phase': false,
          'cpm-request-grid-external': true,
          'cpm-status-review-request': false,
          'cpm-max-file-upload-size': 0
        },
        timestamp: Date.now()
      };
    }
  }
}

export default new FallbackService();